import React, { useState, useEffect } from "react";

export const svg = `<svg width="24" height="24" viewbox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m10.203 10.267-.005-.003a.874.874 0 0 0-.577-.186H8.51a.096.096 0 0 0-.096.096v1.29c0 .053.043.096.096.096h1.112c.246 0 .435-.07.58-.199a.692.692 0 0 0 .218-.537c0-.284-.083-.456-.216-.557Zm5.807 2.465-.005-.005c-.118-.111-.287-.177-.53-.177h-1.272a.096.096 0 0 0-.096.095v1.18c0 .053.043.096.096.096h1.262c.274 0 .45-.066.558-.17.107-.103.174-.269.174-.53 0-.23-.069-.385-.187-.49Zm-1.807-1.524h1.094c.231 0 .388-.053.493-.139.104-.086.165-.214.165-.412 0-.216-.062-.35-.159-.433-.103-.09-.262-.146-.5-.146h-1.093a.096.096 0 0 0-.096.096v.939c0 .052.043.095.096.095Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M13.414 2.988a2.847 2.847 0 0 0-2.828 0l-5.743 3.29a2.802 2.802 0 0 0-1.414 2.43v6.582a2.8 2.8 0 0 0 1.414 2.43l5.743 3.291a2.847 2.847 0 0 0 2.828 0l5.743-3.29a2.802 2.802 0 0 0 1.414-2.43V8.708a2.802 2.802 0 0 0-1.414-2.43l-5.743-3.291ZM6.827 14.983V9.016c0-.231.19-.419.423-.419h2.39c.698 0 1.28.198 1.733.607.456.405.679.951.679 1.62 0 .667-.216 1.212-.659 1.618-.436.405-1.027.599-1.753.599H8.51a.096.096 0 0 0-.097.095v1.847a.42.42 0 0 1-.422.419H7.25a.42.42 0 0 1-.423-.42Zm10.338-.165-.002.002c-.424.4-1.1.582-1.987.582h-2.232a.42.42 0 0 1-.423-.42V9.017c0-.231.19-.419.423-.419h2.511c.613 0 1.12.18 1.504.555.387.364.582.816.582 1.348 0 .507-.191.917-.565 1.217.2.125.37.291.508.496.202.284.3.623.3 1.009 0 .652-.203 1.19-.619 1.596Z" fill="currentColor"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
